import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Stack, Drawer } from '@mui/material'
import * as React from 'react'
import useResponsive from '../../../hooks/useResponsive'
import { NAV } from '../../../config-global'
import Logo from '../../../components/logo'
import Scrollbar from '../../../components/scrollbar'
import { NavSectionVertical } from '../../../components/nav-section'
import { useNavData } from './config-navigation'
import NavToggleButton from './NavToggleButton'
import { useNavVerticalContext } from './NavVerticalContext'
import NavImpersonate from './NavImpersonate'
import NavActions from './NavActions'

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
}

export default function NavVertical({ openNav, onCloseNav }) {
  const location = useLocation()
  const { navData } = useNavVerticalContext()
  const defaultNavData = useNavData()
  const isDesktop = useResponsive('up', 'lg')

  const navConfig = navData || defaultNavData

  useEffect(() => {
    if (openNav) {
      onCloseNav()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, location?.pathname])

  const renderContent = (
    <Stack sx={{ height: 1 }}>
      <Scrollbar
        sx={{
          height: 1,
          '& .simplebar-content': {
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Stack
          spacing={3}
          sx={{
            pt: 3,
            pb: 2,
            px: 2.5,
            flexShrink: 0,
            alignItems: 'center',
          }}
        >
          <Logo />
        </Stack>

        <NavImpersonate />

        <NavSectionVertical data={navConfig} />

        <Box sx={{ flexGrow: 1 }} />
      </Scrollbar>

      <NavActions />
    </Stack>
  )

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  )
}
